import { TERMINAL_NODE_ID } from '../../config';
import { useGraphContext } from '../../context/graph/hook';
import { PanelTabsLayout, TemplateOutput } from '../../molecules';
import { NodeOutput } from '../../molecules/node-output/node-output';
import { DrawerKind } from '../../store/ui';
import { t } from 'i18next';

export const GraphConfigPanel = () => {
  const [closeDrawer, drawer] = useGraphContext(({ ui }) => [
    ui.closeDrawer,
    ui.drawer,
  ]);
  const defaultTab =
    drawer.kind === DrawerKind.GraphConfig ? drawer.tab : 'template';

  return (
    <PanelTabsLayout
      title={t('graphEditor.graphConfig.title')}
      onClose={closeDrawer}
      defaultTab={defaultTab}
      tabs={[
        // {
        //   value: 'general',
        //   label: 'General',
        //   content: (
        //     <Box px="md" pt="md" sx={{ flex: 1 }}>
        //       <Text fz="sm" c="dimmed">
        //         General settings placeholder.
        //       </Text>
        //     </Box>
        //   ),
        // },
        {
          value: 'template',
          label: t('graphEditor.graphConfig.templateTab'),
          content: <TemplateOutput nodeId={TERMINAL_NODE_ID} />,
        },
        {
          value: 'output',
          label: t('graphEditor.graphConfig.outputTab'),
          content: <NodeOutput nodeId={TERMINAL_NODE_ID} mode="evaluation" />,
        },
      ]}
    />
  );
};
